import { resolveReturnPathForLogin } from './authSessionExpired';

const STORAGE_KEY = 'nky_connect_send_inquiry_resume';

/**
 * Persist send-inquiry context so after sign-in we can link the wizard search, reload it, and reopen the modal.
 * @param {object} payload
 * @param {string} payload.returnPath pathname + search when the user left for login
 * @param {string} payload.businessId
 * @param {string} [payload.businessName]
 * @param {string} payload.wizardSearchRequestId
 * @param {string} [payload.clientSessionId] guest browser session — required to PATCH linkToAccount after login
 */
export function setSendInquiryResume(payload) {
  try {
    const normalized = {
      ...payload,
      returnPath: resolveReturnPathForLogin(payload.returnPath),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  } catch {
    /* ignore */
  }
}

/** Clears pending send-inquiry resume (wizard search id / route) without consuming. */
export function clearSendInquiryResumeStorage() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * @returns {object | null}
 */
export function consumeSendInquiryResume() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    const data = JSON.parse(raw);
    const here = resolveReturnPathForLogin(
      `${window.location.pathname}${window.location.search}`,
    );
    const savedPath = data.returnPath
      ? resolveReturnPathForLogin(data.returnPath)
      : null;
    if (savedPath && savedPath !== here) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}
